import {
  isWorkerInviteRequired,
  isWorkerRestricted,
} from "@src/appV2/redesign/ClipboardScore/utils/utils";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useEmergencyCreditsConfig } from "./useEmergencyCreditsConfig";

interface UseEmergencyCreditsClockOutFlowResult {
  isEligibleForECFlow: boolean;
}

export function useEmergencyCreditsClockOutFlow(): UseEmergencyCreditsClockOutFlowResult {
  const worker = useDefinedWorker();
  const emergencyCreditsConfig = useEmergencyCreditsConfig();

  const isECEnabled = emergencyCreditsConfig.enabled;
  const isRestricted = isWorkerRestricted(worker);
  const isInviteRequired = isWorkerInviteRequired(worker);

  const isEligibleForECFlow = isECEnabled && !isRestricted && !isInviteRequired;

  return { isEligibleForECFlow };
}
